/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerDocumentErrorMetadataRelatedDocumentInformationInner } from './ScreenerDocumentErrorMetadataRelatedDocumentInformationInner';
import {
    ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSON,
    ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSONTyped,
    ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSON,
} from './ScreenerDocumentErrorMetadataRelatedDocumentInformationInner';

/**
 * 
 * @export
 * @interface ScreenerDocumentErrorMetadata
 */
export interface ScreenerDocumentErrorMetadata {
    /**
     * 
     * @type {Array<ScreenerDocumentErrorMetadataRelatedDocumentInformationInner>}
     * @memberof ScreenerDocumentErrorMetadata
     */
    related_document_information?: Array<ScreenerDocumentErrorMetadataRelatedDocumentInformationInner>;
    /**
     * Reason for the error (used with PROCESSING_ERROR type)
     * @type {string}
     * @memberof ScreenerDocumentErrorMetadata
     */
    reason?: string;
    /**
     * Human-readable error message (used with PROCESSING_ERROR type)
     * @type {string}
     * @memberof ScreenerDocumentErrorMetadata
     */
    message?: string;
}

/**
 * Check if a given object implements the ScreenerDocumentErrorMetadata interface.
 */
export function instanceOfScreenerDocumentErrorMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScreenerDocumentErrorMetadataFromJSON(json: any): ScreenerDocumentErrorMetadata {
    return ScreenerDocumentErrorMetadataFromJSONTyped(json, false);
}

export function ScreenerDocumentErrorMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerDocumentErrorMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'related_document_information': !exists(json, 'related_document_information') ? undefined : ((json['related_document_information'] as Array<any>).map(ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSON)),
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ScreenerDocumentErrorMetadataToJSON(value?: ScreenerDocumentErrorMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'related_document_information': value.related_document_information === undefined ? undefined : ((value.related_document_information as Array<any>).map(ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSON)),
        'reason': value.reason,
        'message': value.message,
    };
}

